import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Typography,
  styled,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { Button, Stack, TextField, Grid } from "@mui/material";
import { BodyContainer, HeaderTitle } from "../../pages/bank/styles";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import { getVendors } from "../vendors/vendorSlice";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";
import { Toast } from "../components/Toast";
import Repo from "../../Repository/Repo";
import SearchItem from "./SearchItem";
import { toRemoveItems } from "./purchaseSlice";
import EditPrice from "./EditPrice";
import ItemHistory from "./ItemHistory";
import { useHistory } from "react-router-dom";
import ItemsTable from "./ItemsTable";
import { purchaseItems } from "../inventory/itemsSlice";
import { v4 as uuidv4 } from "uuid";
import { Header } from "./styles";
import { PurchasePrint } from "./PurchasePrint";
import { BtnBack, BtnHeader, HeadBox, RowBox, SubTitle } from "./styles";
import { saveLedger } from "../ledgers/httpCalls";
import useGetBanks from "../../pages/bank/useGetBanks";
import PurchaseRepository from "../../Repository/PurchaseRepository";
import AddItem from "../inventory/AddItem";
import DialogComponent from "../reusableComponents/Dialog";
// import AddBatchPurchase from "./AddBatchPurchase"

const TotalBox = styled(Box)({
  backgroundColor: "white",
  borderRadius: "8px",
  padding: "15px 10px",
  color: "#757575",
  marginTop: "10px",
});

function PurchaseOrders() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { vendors } = useSelector((state) => state.vendor);
  const { items } = useSelector((state) => state.purchase);
  // const { pay } = useSelector((state) => state.purchase);
  const { totalPurchaseAmount } = useSelector((state) => state.purchase);
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const userName = localStorage.getItem("username");
  const [ledger, setLedger] = useState("");
  const [vendor, setVendor] = useState("");
  const [filterText, setFilterText] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [selected, setSelected] = useState(null);
  const [modal, setModal] = useState(false);
  const [EditModal, setEditModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [user, setUser] = useState("");
  const [pay, setPay] = useState(0);
  const [type, setType] = useState({
    name: "Other",
    depositTo: "",
  });

  const [state, setState] = useState({
    ledgerSelection: false,
    ledger_id: "new",
    idString: "new",
    nameNumber: "",
    broughtForward: "",
    amount: "",
    date: "",
    category: "",
    type: "",
    ledgerId: "",
    ledgerName: "",
    balance: 0,
    depositTo: "",
    forwardType: "add",
    addModal: false,
    purchases: [],
    new_ledger: {
      ledger_type: "customer",
      address: "",
      name: "",
      region: "",
    },
  });

  console.log("ledger", ledger);
  console.log("vendor", vendor);
  console.log("itemsssssss", items);
  
  useEffect(() => {
    if (vendors.length == 0) {
      dispatch(getVendors());
    }
    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
    getUser();
  }, []);

  useEffect(() => {
    setLedger((prev) => ({ ...prev, depositedPurchaseTotal: pay }));
  }, [pay]);

  useEffect(() => {
    getOrders();
  }, []);

  const { banks } = useGetBanks();

  const getUser = async () => {
    let { data } = await Repo.user({
      request: {
        method: "getUser",
        data: {
          _id: localStorage.getItem("token"),
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      setUser(data.response.data.user);
    }
  };

  const getOrders = async () => {
    // setState((prev) => ({ ...prev, loading: true }));
    let { data } = await PurchaseRepository.purchasesModel({
      request: {
        method: "getPurchases",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    console.log("data:", data);
    setState((prev) => ({
      ...prev,
      // loading: false,
      purchases: data.response.data.purchases,
    }));
  };

  const handleSelection = () => {
    setState((pre) => ({
      ...pre,
      ledgerSelection: !pre.ledgerSelection,
      ledger_id: "new",
      idString: "new",
    }));
  };
  const handleBack = () => {
    setState((pre) => ({
      ...pre,
      ledgerSelection: false,
      ledger_id: "new",
      idString: "new",
      new_ledger: {
        ledger_type: "customer",
        address: "",
        name: "",
      },
    }));
  };
  const handleNewLedger = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let _id = uuidv4();
    let id = _id.replaceAll("-", "");
    console.log("name", name);
    console.log("value", value);
    if (name == "name") {
      setLedger((prev) => ({
        ...prev,
        name: value,
        ledgerType: "supplier",
        _id: id,
      }));
    } else if (name == "address") {
      setLedger((prev) => ({
        ...prev,
        address: value,
        ledgerType: "supplier",
        _id: id,
      }));
    }

    setState((pre) => ({
      ...pre,
      new_ledger: {
        ...pre.new_ledger,
        [name]: value,
      },
    }));
  };
  const editToggle = (item = null) => {
    setSelected(item);
    setEditModal((prev) => !prev);
  };
  const historyToggle = (item = null) => {
    if (item && !ledger) {
      Toast("info", "Kindly select a ledger");
      return;
    }
    setSelected(item);
    setHistoryModal((prev) => !prev);
  };

  const onSuccess = () => {
    setSearchItem("");
    setModal(false);
  };
  const toggle = (arg) => {
    if (arg && !searchItem) {
      Toast("info", "Enter item name");
      return;
    }
    setModal((prev) => !prev);
  };
  const handleModal = (name, open = "") => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleInput = (e, val, arg) => {
    const { name, value } = e.target;
    console.log("vale", value);
    console.log("val", val);
    console.log("ss", state.purchases);
    //   const selectedPurchases = state?.purchases?.filter((item) => {
    //     return item.ledger?.trim().toLowerCase() === val._id?.trim().toLowerCase();
    // });

    // console.log('selectedPurcahse', selectedPurchases)
    if (arg == "ledger") {
      setLedger(val);
    } else if (arg == "vendor") {
      setVendor(val);
    } else {
      setFilterText(value);
    }
  };

  const handleInputNew = (e) => {
    const { name, value } = e.target;
    console.log("vvv", value);
    // if(name == "mode") {
    //   dispatch(getLedgerDetail({type:value,id:state.ledgerId}))
    // }
    const selectedBank = e.target.value;
    console.log("ssssss',selectedBank", selectedBank);

    setType((prev) => ({ ...prev, [name]: value }));
  };

  const getTotal = useMemo(() => {
    let myTotal = 0;
    items?.forEach((item) => {
      let newQty;
      newQty = item.newQuantity ? item.newQuantity : 1;
      let totalDiscount;
      let price = item.newPrice
        ? parseFloat(item.newPrice)
        : parseFloat(item.companyPrice);
      let itemDiscount = item.saleDiscount
        ? parseInt(item.saleDiscount)
        : item.saleDiscount == ""
        ? parseInt(item.saleDiscount)
        : parseInt(item.discount);
      let finalPrice = newQty * price;
      console.log("final", finalPrice);
      if (itemDiscount) {
        let eachValue = (itemDiscount / 100) * finalPrice;
        totalDiscount = Math.ceil(eachValue);
        console.log("total", totalDiscount);
      } else {
        totalDiscount = 0;
      }
      myTotal = Math.ceil(myTotal + newQty * price - totalDiscount);
      console.log("myTotal", myTotal);
    });

    return myTotal;
  }, [items]);

  const updateInventory = (arg) => {
    return Repo.default({
      request: {
        method: "updateItem",
        data: {
          items: arg,
          action: "Purchase",
          user: localStorage.getItem("token"),
        },
      },
    });
  };

  const updateLed = (prNum) => {
    return Repo.ledger({
      request: {
        method: "updatePurchaseLedger",
        data: {
          _id: ledger._id,
          purchase: {
            srNum: uuidv4(),
            billNumber: prNum,
            date: +new Date(),
            detail: `Purchase Order # ${prNum} entry created`,
            totalAmount: getTotal,
            depositedAmount: ledger?.depositedPurchaseTotal || 0,
            remainingAmount:
              getTotal - Number(ledger?.depositedPurchaseTotal || 0),
          },
        },
      },
    });
  };

  const paymentCashBankHandler = async (id) => {
    console.log("id", id);

    let method =
      type.name === "Cash" ? "paymentyByCashInHand" : "paymentByBank";
    const currentDate = new Date();

    // Extract day, month, and year
    const day = String(currentDate.getDate()).padStart(2, "0"); // Ensures two digits
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = currentDate.getFullYear();

    // Format the date as dd-mm-yyyy
    const formattedDate = `${day}-${month}-${year}`;

    console.log(formattedDate);
    let { data } = await Repo.banks({
      request: {
        method: method,
        data: {
          company_code: localStorage.getItem("companyCode"),
          ledgerId: ledger._id,
          credit: 0,
          debit: Number(pay),
          paymentId: id,
          from: type.name == "Cash" ? "cashInHand" : userName,
          to: ledger?.name ? ledger?.name : "",
          description: "",
          bankId: type?.depositTo?._id,
          date: formattedDate,
        },
      },
    });

    console.log("dataa", data);
  };

  const createPurchase = async () => {
    console.log("type", type.name);

    let { data } = await Repo.purchases({
      request: {
        method: "savePurchase",
        data: {
          company_code: localStorage.getItem("companyCode"),
          purchase: {
            company_code: localStorage.getItem("companyCode"),
            items: items,
            ship: {
              name: user.name,
              city: user?.address?.city,
              company: user?.company_name,
              street: user?.address?.street,
              phone: user?.address?.phone,
            },
            vendor: vendor,
            ledger: ledger._id || "",
            ledger_detail: ledger,
            paid: pay || 0,
            user_id: localStorage.getItem("email"),
            remaining: Number(getTotal - pay) || 0,
            total: Number(getTotal) || 0,
            srNum: uuidv4(),
            purchaseMode: type.name,
            bankId: type?.depositTo?._id,
          },
        },
      },
    });
    if (data.response.data.purchaseNumber) {
      console.log("data:", data);
      console.log("data:", data.response.status.statusCode);
      const res = data.response.status.statusCode;
      await res;
      const paymentId = data.response.data.purchase;

      console.log("payment", paymentId);

      if (pay > 0 && type.name !== "Other") {
        await paymentCashBankHandler(paymentId);
      }
      return data.response.data.purchaseNumber;
    } else {
      Toast("error", "Error");
      return null;
    }
  };

  const foundBatch = useMemo(() => {
    let found = items.find((item) => {
      if (item?.batchNumber && item?.batchNumber.length > 0) {
        return item;
      }
    });
    if (found) {
      return true;
    } else {
      return false;
    }
  }, [items]);

  const handlePurchase = async () => {
    if (items.length == 0) {
      Toast("info", "Kindly add items");
      return;
    }

    if (!ledger.name) {
      Toast("info", "Kindly Select Supplier");
      return;
    }

    if (!type.name) {
      Toast("info", "No Purchase Mode Selected");
      return;
    }
    // if (!ledger._id ) {
    //   Toast("info", "No Supplier Selected");
    //   return;
    // }
    try {
      setIsLoading(true);
      let updatedItems = [];
      let newItems;
      let fullItems = [];
      items.forEach((item) => {
        let newprice = item.newPrice
        newItems = {
          ...item,
        ...(newprice !=null && {newPrice: Number(newprice)})
        }
        if(item.costPrice == "" && newprice == null) {
          Toast("info", `Please Enter New Price of ${item?.name}`);
        }
        let qty = item.newQuantity ? item.newQuantity : 1;
        if (foundBatch) {
          if (item.batchNo) {
            let updateItem = {
              _id: item._id,
              purchaseQuantity: qty,
              batchNo: item.batchNo,
            };
            // let found = item.batchNumber.find(
            //   (i) => i.batchNumber == item.batchNo
            // );
            // found.quantity = parseInt(found.quantity) + parseInt(qty);
            updatedItems.push(updateItem);
            fullItems.push({ ...newItems, purchaseQuantity: qty });
          } else {
            let updateItem = {
              _id: item._id,
              purchaseQuantity: qty,
            };
            updatedItems.push(updateItem);
            fullItems.push({ ...newItems, purchaseQuantity: qty });
          }
        } else {
          let updateItem = {
            _id: item._id,
            purchaseQuantity: qty,
          };
          updatedItems.push(updateItem);
          fullItems.push({ ...newItems, purchaseQuantity: qty });
        }
      });

      dispatch(toRemoveItems());
      dispatch(purchaseItems(updatedItems));
      PurchasePrint(vendor, ledger, items, getTotal, pay, user);
      if (state.new_ledger.address) {
        let data = await saveLedger(ledger, dispatch);
        console.log(data);
      }

      let res = await createPurchase();
      if (res) {
        Promise.all([updateInventory(fullItems), updateLed(res)])
          .then((res) => {
            setIsLoading(false);
            history.push("/inventory/admin/purchase-order/finalized");
          })
          .catch((err) => {
            console.log(err);
            setIsLoading(false);
          });
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      console.log("err:", err);
      setIsLoading(false);
    }
  };
  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name == "pay") {
      setPay(value);
    }
  };
  return (
    <Box>
      <Header>
        <HeaderTitle> </HeaderTitle>
        <HeaderTitle>Purchase Orders</HeaderTitle>
        <HeaderTitle> </HeaderTitle>
      </Header>
      <BodyContainer sx={{ mt: "8px" }}>
        <Grid container spacing="8px" mb="8px" sx={{ flexDirection: "column" }}>
          {state.ledgerSelection == false && (
            <Button
              sx={{
                fontSize: { md: "16px", xs: "14px" },
                mt: "8px",
                lineHeight: "120%",
                textTransform: "none",
                padding: "0px",
                width: "30%",
              }}
              onClick={handleSelection}
              className="ledger-font-sm-10"
            >
              Add New Supplier
            </Button>
          )}
          {state.ledgerSelection == false && (
            <Grid item md={4} sm={6} xs={12}>
              <Autocomplete
                autoFocus
                size="small"
                value={ledger}
                onChange={(e, val) => {
                  handleInput(e, val, "ledger");
                }}
                fullWidth
                getOptionLabel={(option) => option?.name || ""}
                options={ledgersNames}
                renderInput={(params) => (
                  <TextField autoFocus {...params} label="Select Supplier" />
                )}
              />
            </Grid>
          )}

          <Grid item md={4} sm={6} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Select Transaction Mode</InputLabel>
              <Select
                name="name"
                value={type.name}
                label="Select Transaction Mode"
                onChange={handleInputNew}
              >
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Bank">Bank</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {type.name == "Bank" && (
            <Grid item md={4} sm={6} xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Bank Name</InputLabel>
                <Select
                  size="small"
                  name="depositTo"
                  value={type.depositTo}
                  label="Bank Name"
                  onChange={handleInputNew}
                >
                  {banks.map((item, i) => {
                    return (
                      <MenuItem key={i} value={item}>
                        {item.bankName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          )}

          <Box textAlign="center" sx={{ width: "30%" }}>
            {state && state.ledgerSelection === true && (
              <Button onClick={handleBack}>Back</Button>
            )}
          </Box>
          <Box>
            {state.ledgerSelection == true && (
              <>
                <h4 style={{ margin: "0 auto", padding: "10px" }}>
                  Create new Supplier
                </h4>
                {state.ledger_id === "new" && (
                  <TextField
                    size="small"
                    variant="outlined"
                    required
                    name="name"
                    value={state.new_ledger.name}
                    onChange={handleNewLedger}
                    placeholder="Create Supplier Name"
                  />
                )}

                {state.ledger_id === "new" && (
                  <TextField
                    size="small"
                    variant="outlined"
                    value={state.new_ledger.address}
                    required
                    name="address"
                    onChange={handleNewLedger}
                    placeholder="Enter Detail"
                  />
                )}
              </>
            )}
          </Box>

          {/* <Grid item md={4} sm={6} xs={12}>
            <Autocomplete
              size="small"
              value={vendor}
              onChange={(e, val) => {
                handleInput(e, val, "vendor");
              }}
              fullWidth
              getOptionLabel={(option) => option.companyName || ""}
              options={vendors}
              renderInput={(params) => (
                <TextField {...params} label="Select Vendor" />
              )}
            />
          </Grid> */}
          {/* <Grid item md={4} sm={6} xs={12} >
            <Button variant="contained">
              Add Item
            </Button>
          </Grid> */}
        </Grid>
        <Button variant="contained" onClick={() => handleModal("addModal")}>
          Add New Item
        </Button>

        <Box
          sx={{
            maxHeight: "84vh",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <ItemsTable ledger={ledger} />
        </Box>

        <Grid container sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Grid item md={3} sm={6} xs={12}>
            <TotalBox>
              <Stack
                direction="row"
                justifyContent="space-between"
                padding="5px"
              >
                <Typography>Total:</Typography>
                <Typography>{getTotal}</Typography>
              </Stack>

              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                padding="5px"
              >
                <Typography>Pay:</Typography>
                <TextField
                  fullWidth
                  type="number"
                  size="small"
                  variant="outlined"
                  // label="Pay"
                  // max={item?.pay}
                  name="pay"
                  value={pay}
                  onChange={(e) => handleChange(e)}
                />
              </Stack>
              <DialogComponent
                title="Add Item"
                open={state.addModal}
                onClose={() => handleModal("addModal")}
                dialogContent={
                  <AddItem
                    onClose={() => handleModal("addModal")}
                    items={items}
                    // myShops={myshops}
                  />
                }
              />
              <hr />
              <Stack alignItems="center" justifyContent="center" padding="5px">
                {isLoading && (
                  <ClipLoader size={50} color={"#4DAF51"} loading={true} />
                )}
                {!isLoading && (
                  <Button variant="contained" onClick={handlePurchase}>
                    Purchase Now
                  </Button>
                )}
              </Stack>
            </TotalBox>
          </Grid>
        </Grid>
      </BodyContainer>
      
      {modal && (
        <SearchItem item={searchItem} onClose={toggle} onSuccess={onSuccess} />
      )}
      {EditModal && <EditPrice onClose={editToggle} item={selected} />}
      {historyModal && (
        <ItemHistory onClose={historyToggle} item={selected} ledger={ledger} />
      )}
    </Box>
  );
}

export default PurchaseOrders;
